/** Base URL for Webflow export copied at build time (see angular.json assets). */
export const WF_STATIC_BASE = '/webflow-static';

export function wfImage( name: string ): string {

  return `${ WF_STATIC_BASE }/images/${ name }`;
}
